// +----------------------------------------------------------------------
// | AI 消息气泡（追问 / 结论 / 用户回答）
// | role: 'ai' | 'user'；loading 时显示三点动效
// +----------------------------------------------------------------------
import './AIMessage.less';

export default function AIMessage({ role = 'ai', children, content, loading = false, tone = '' }) {
  const isUser = role === 'user';

  return (
    <div className={`ai-message ${isUser ? 'is-user' : 'is-ai'} ${tone ? `tone-${tone}` : ''}`}>
      {!isUser && <div className="ai-message-avatar">想</div>}

      <div className="ai-message-body">
        {loading ? (
          <span className="dots">
            <i />
            <i />
            <i />
          </span>
        ) : (
          children || <span className="ai-message-text">{content}</span>
        )}
      </div>
    </div>
  );
}
